import * as React from 'react'
import { useTranslation } from 'react-i18next'

import * as NotificationActions from '../../../actions/notifications'
import * as StoresActions from '../../../actions/stores'
import { useAppDispatch } from '../../../actions/types'
import {
    Centered,
    Link,
    Loader,
    Margin,
    Notes,
} from '../../../components'
import {
    NotesBoard,
    NotesBody,
    NotesHeader,
} from '../../../components/Screens/Estate/Store/Store.styles'
import { useAppSelector } from '../../../reducers'
import type { StoreWithDevices } from '../../../types/StoreMain'
import SingleNote from '../../Notes/SingleNote'

function StoreNotes() {
    const dispatch = useAppDispatch()

    const isWorking = useAppSelector(state => state.stores.isWorking)
    const selectedStore = useAppSelector<StoreWithDevices>((state) => state.stores.selectedStore)

    const [note, setNote] = React.useState('')
    const [image, setImage] = React.useState<string>()
    const [notesCount, setNotesCount] = React.useState(5)

    const { t } = useTranslation()

    const { code: storeCode, notes = [] } = selectedStore ?? {}
    const notesToRender = notes.slice(0, notesCount)

    const onChangeInput = ({ target: { value } }: { target: { value: string } }) => {
        setNote(value)
    }

    const onChangeImage = ({ target: { files = [] } }) => {
        setImage(files[0])
    }
    
    const onSubmitNote = (parentID: string): boolean => {
        if (!selectedStore) {
            dispatch(NotificationActions.notify({ title: 'Error', body: 'None store selected' }))
            return false
        }

        dispatch(
            StoresActions.storeNote(
                { storeCode, note, image },
                parentID,
            ),
        )

        setNote('')
        setImage(undefined)

        return true
    }

    return (
        <NotesBoard>
            <NotesHeader>
                {t('Notes')}
                <Notes
                    image={image}
                    onChange={onChangeInput}
                    onChangeImage={onChangeImage}
                    onSubmit={onSubmitNote}
                    value={note}
                />
            </NotesHeader>
            {isWorking && (
                <Centered horizontal>
                    <Margin top><Loader /></Margin>
                </Centered>
            )}
            {!isWorking && (
                <NotesBody>
                    {notesToRender.map((noteList, index) => (
                        <SingleNote
                            index={index}
                            key={noteList.id}
                            note={noteList}
                            onChangeNote={onChangeInput}
                            onChangeNoteImage={onChangeImage}
                            onSubmitNote={onSubmitNote}
                            valueImage={image}
                            valueNote={note}
                        />
                    ))}
                    {notesToRender.length !== notes.length && (
                        <Link
                            onClick={() => {
                                setNotesCount(notesCount + 5)
                            }}
                        >
                            Load more
                        </Link>
                    )}
                </NotesBody>
            )}
        </NotesBoard>
    )
}

export default StoreNotes
